import React, {useEffect, useMemo, useState} from 'react';
import {observer} from 'mobx-react-lite';

import {
  View,
  Text,
  StyleSheet,
  Animated,
  Pressable,
  LayoutChangeEvent,
} from 'react-native';
import Svg, {Mask, Path, Rect} from 'react-native-svg';
import {v4 as uuidV4} from 'uuid';

import Close from '../assets/svg/colorless/close.svg';
import {variance} from '../styling';
import {useStrings} from '../Root/hooks';
import {sized} from '../Svg';

import {PressableOpacity} from '../components';
import {Layout} from '../DashboardSlotBacklight';

export type FreeMinerScreenProps = {
  layout: Layout;
  onClose(): void;
  isDesktop: boolean;
};

export default observer(function FreeMinerScreen({
  layout,
  onClose,
  isDesktop,
}: FreeMinerScreenProps) {
  return (
    <RootView>
      <BackgroundMask el={layout} onClose={onClose} isDesktop={isDesktop} />
      <Tooltip position={layout} onClose={onClose} isDesktop={isDesktop} />
    </RootView>
  );
});
const RootView = variance(View)(() => ({
  root: {
    ...StyleSheet.absoluteFillObject,
  },
}));

const CloseIcon = sized(Close, 16);

const BackgroundMask = observer(
  (props: {el: Layout; onClose: () => void; isDesktop: boolean}) => {
    const {el, onClose, isDesktop} = props;

    if (!el) {
      return null;
    }

    const maskId = uuidV4();
    const config = useMemo(() => {
      return {
        y: el.pageY,
        x: (isDesktop ? (el.width - 1100) / 2 : el.pageX) + 1,
        width: (isDesktop ? 1100 : el.width) - 2, // отнимаются размеры бордеров  воркера
        height: el.height - 1,
      };
    }, [el, isDesktop]);
    return (
      <PressableOpacity style={StyleSheet.absoluteFillObject} onPress={onClose}>
        <Svg style={StyleSheet.absoluteFillObject} width="100%" height="100%">
          <Mask id={maskId}>
            <Rect x="0" y="0" width="100%" height="100%" fill="white" />
            <Rect
              x={config.x}
              y={config.y}
              width={config.width}
              height={config.height}
              fill="black"
              rx={15}
              ry={15}
            />
          </Mask>

          <Rect
            width="100%"
            height="100%"
            fill="black"
            opacity={0.7}
            mask={`url(#${maskId})`}
          />
        </Svg>
      </PressableOpacity>
    );
  },
);

const Tooltip = (props: {
  position: Layout;
  onClose: () => void;
  isDesktop: boolean;
}) => {
  const {position, onClose, isDesktop} = props;
  const [fadeAnim] = useState(new Animated.Value(0));
  const [translateY] = useState(new Animated.Value(20));
  const [tooltipSize, setTooltipSize] = useState({width: 0, height: 0});
  const strings = useStrings();

  useEffect(() => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 500,
        useNativeDriver: true,
      }),
      Animated.timing(translateY, {
        toValue: 0,
        duration: 500,
        useNativeDriver: true,
      }),
    ]).start();
  }, [translateY, fadeAnim]);

  const onTooltipLayout = (event: LayoutChangeEvent) => {
    const {width, height} = event.nativeEvent.layout;
    setTooltipSize({width, height});
  };
  console.log('isDesktop', isDesktop);
  console.log(isDesktop ? (position.width - 1100) / 2 : position.pageX);
  console.log(position.pageX);
  const tooltipStyle = {
    position: 'absolute',
    left: isDesktop ? (position.width - 1100) / 2 : position.pageX,
    top: position.pageY - tooltipSize.height - 10,
    opacity: fadeAnim,
    right: position.pageX,
    transform: [{translateY}],
    borderRadius: 8,
    ...(isDesktop ? {width: 340} : {}),
  };

  return (
    <Animated.View
      style={[styles.tooltip, tooltipStyle]}
      onLayout={onTooltipLayout}>
      <TooltipContainerView>
        <Pressable style={styles.closeButton} onPress={onClose}>
          <CloseIcon color="#67ACF1" />
        </Pressable>

        <TooltipText>{strings['dashboard.freeMiner.tooltip']}</TooltipText>
      </TooltipContainerView>

      <View style={styles.svgWrapper}>
        <Svg width="30" height="12" viewBox="0 0 30 12" fill="none">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.998 12C19.498 12 23.9979 0 29.998 0H-0.00195312C5.9604 0 10.498 12 14.998 12Z"
            fill="#2285EB"
          />
        </Svg>
      </View>
    </Animated.View>
  );
};

const TooltipContainerView = variance(View)(() => ({
  root: {
    padding: 12,
    backgroundColor: '#2285EB',
    borderRadius: 8,
    paddingRight: 36,
  },
}));
const TooltipText = variance(Text)((theme) => ({
  root: {
    ...theme.fontByWeight(),
    color: '#C5DFFA',
    fontSize: 14,
  },
}));
const styles = StyleSheet.create({
  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    opacity: 0.9,
  },
  container: {
    ...StyleSheet.absoluteFillObject,
  },
  tooltip: {
    borderRadius: 20,
  },

  svgWrapper: {flex: 1, marginTop: -1, alignItems: 'center'},
});
